<template>
  <v-container
    d-flex
    justify-center
    class="article-tip-image-container pointer"
    @click="item.videoSrc ? openVideo() : null"
    pl-0
    pr-0
    pt-0
  >
    <v-img
      position="top center"
      class="round-corners"
      :height="height"
      :class="darkMode ? 'dark' : 'mb-1'"
      :src="previewImage"
    ></v-img>
    <v-icon
      absolute
      color="#ffffff"
      size="60"
      class="absolute mdi mdi-youtube play-button"
      v-if="item.videoSrc"
    />
  </v-container>
</template>
 
<script>
import ArticlePreviewImageVue from './mixins/ArticlePreviewImage.js';

export default {
  mixins: [ArticlePreviewImageVue],
  props: {
    height: {
      type: String,
      required: false,
      default: '161px',
    },
    item: {
      type: Object,
      required: false,
    },
    darkMode: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.round-corners {
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  cursor: pointer;
}

.round-corners.dark {
  -webkit-border-top-left-radius: 5px;
  -moz-border-top-left-radius: 5px;
  border-top-left-radius: 5px;
  -webkit-border-top-right-radius: 5px;
  -moz-border-top-right-radius: 5px;
  border-top-right-radius: 5px;
  -webkit-border-bottom-left-radius: 0px;
  -moz-border-bottom-left-radius: 0px;
  border-bottom-left-radius: 0px;
  -webkit-border-bottom-right-radius: 0px;
  -moz-border-bottom-right-radius: 0px;
  border-bottom-right-radius: 0px;
}

@media screen and (max-width: 960px) {
  .round-corners {
    height: 22vh !important;
  }
}
.play-button {
  position: absolute !important;
  display: flex;
  align-self: center;
  text-shadow: 0px 0px 10px #000000;
}
</style>
